import { http } from '@/utils/http.js';
import { teamPath } from '@/utils/paths.js';

export const UsersApi = {
  getUsers(query) {
    return http.get(`${teamPath()}/users`, { params: query }).then((response) => response.data);
  },

  getUser(id) {
    return http.get(`${teamPath()}/users/${id}`).then((response) => response.data.data);
  },

  updateUser(id, data) {
    return http.patch(`${teamPath()}/users/${id}`, data).then((response) => response.data.data);
  },

  deleteUser(id) {
    return http.delete(`${teamPath()}/users/${id}`).then((response) => response.data.data);
  },
};
